export const GET_CATEGORIES_SLIDER = "GET_CATEGORIES_SLIDER";
